<div [formGroup]="form" *ngIf="form" class="form-responsive"
    (keydown.tab)="$event.stopPropagation()"
    (click)="$event.stopPropagation()">
    <div class="form-group">
        <div fxLayout="column">
            <mat-form-field appearance="outline" class="min-width">
                <mat-label>Nome</mat-label>
                <input type="text" #nomeInput placeholder="Ex.: Metro, Hora, Caixa" matInput
                    formControlName="name" required maxlength="100">
                <mat-error *ngIf="form.get('name')?.hasError('required')">Informe o nome</mat-error>
            </mat-form-field>
            <mat-form-field appearance="outline" class="min-width">
                <mat-label>Abreviação</mat-label>
                <input type="text" placeholder="Ex.: m, h, cx" matInput formControlName="abbr" maxlength="20">
            </mat-form-field>
        </div>
    </div>

    <!-- Fora de diálogo (uso direto na página) -->
    <div *ngIf="!inDialog" class="form-actions">
        <button *ngIf="!unit?.id" type="button" class="oa-btn oa-btn--primary"
            [disabled]="loading || !form.dirty || !form.valid" [attr.aria-busy]="loading || null" (click)="store()">
            <span>Criar unidade</span>
            <span *ngIf="loading" class="oa-spinner" aria-hidden="true"></span>
        </button>
        <button *ngIf="unit?.id" type="button" class="oa-btn oa-btn--primary"
            [disabled]="loading || !form.dirty || !form.valid" [attr.aria-busy]="loading || null" (click)="update()">
            <span>Salvar alterações</span>
            <span *ngIf="loading" class="oa-spinner" aria-hidden="true"></span>
        </button>
    </div>
</div>
